<div style="height: 100%; display: flex;">
  @if (errorMessage) {
    <div class="row">
      <div class="col-md-offset-4 col-md-8">
        {{ errorMessage }}
      </div>
    </div>
  }
  <div class="row">
    <div class="col-md-offset-4 col-md-8">
      Redirection ...
    </div>
  </div>
</div>
